import { createAction } from 'redux-actions'

export const setReferralSourceList = createAction('SET_REFERRAL_SOURCE_LIST')
export const setReferralSourceItem = createAction('SET_REFERRAL_SOURCE_ITEM')

export const resetReferralSource = createAction('RESET_REFERRAL_SOURCE')
